import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logoImage from '../img/Logo.svg';

import logo from "../img/MainLogo.svg"
// import Call from "../img/Frame 33.png"


function Navbar() {
  const handlePhoneCall = () => {
    window.location.href = "tel:(888) 202 1350"
  }

  const handleLogoClick = () => {
    window.location.href = "/"
  }


  return (
    <nav className="bg-white shadow-md fixed top-0 left-0 right-0 z-50">
      <div className="max-w-6xl mx-auto flex items-center h-20">
        {/* Logo - Centered on mobile, left-aligned on desktop */}
        <div className="flex items-center justify-center md:justify-start flex-1 md:flex-none" onClick={handleLogoClick}>
          <img src={logo} alt="Logo" className="h-8 w-auto"  />
        </div>

        {/* Navigation Links - Centered */}
        <div className="hidden md:flex md:items-center md:space-x-8 flex-1 justify-center">
          <Link to="/aboutus" className="text-gray-500 hover:text-[#2C3E50] transition-colors duration-300 no-underline">About Us</Link>
          <Link to="/contactus" className="text-gray-500 hover:text-[#2C3E50] transition-colors duration-300 no-underline">Contact Us</Link>
        </div>

        {/* Call to Action Button */}
        {/*  */}
      </div>
    </nav>
  );
}

export default Navbar; 